// extracted by mini-css-extract-plugin
export default {"page":"mainPage_page__NxE6H"};